export default __webpack_public_path__ + "static/media/about-us-oslo.78400e18.webm";